/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Content_LabelInputs */

const en_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

const fr_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu`)
};

const de_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt`)
};

const it_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuto`)
};

const ru_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Содержание`)
};

const es_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido`)
};

const zh_cn2_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容`)
};

const ja_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツ`)
};

const hi_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामग्री`)
};

const pt_pt2_error_nav_content_label = /** @type {(inputs: Error_Nav_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contente`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Error_Nav_Content_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_content_label = /** @type {((inputs?: Error_Nav_Content_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Content_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_content_label(inputs)
	if (locale === "de") return de_error_nav_content_label(inputs)
	if (locale === "it") return it_error_nav_content_label(inputs)
	if (locale === "ru") return ru_error_nav_content_label(inputs)
	if (locale === "es") return es_error_nav_content_label(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_content_label(inputs)
	if (locale === "ja") return ja_error_nav_content_label(inputs)
	if (locale === "hi") return hi_error_nav_content_label(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_content_label(inputs)
	return en_error_nav_content_label(inputs)
});